import styled from 'foundations-theming/utils';
import I18n from 'I18n';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { getRecipientKey } from 'conversations-thread-data/channel-configuration/public/operators';
import RecipientFieldExpandButton from './RecipientFieldExpandButton';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { VerticalMenuIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FIELD_VISIBILITY_CONTROLS_HEIGHT = 40;
export const FieldVisibilityControlsWrapper = styled.div.withConfig({
  displayName: "FieldVisibilityControls__FieldVisibilityControlsWrapper",
  componentId: "sc-106ickt-0"
})(["display:flex;align-items:center;flex-shrink:0;height:", "px;"], FIELD_VISIBILITY_CONTROLS_HEIGHT);
const renderRecipientsExpandButtons = ({
  index,
  recipient,
  recipientFieldsExpansionState,
  setRecipientFieldsExpansionState,
  showCCBCCIconButtons
}) => {
  const recipientKey = getRecipientKey(recipient);
  return /*#__PURE__*/_jsx(RecipientFieldExpandButton, {
    recipientKey: recipientKey,
    index: index,
    recipientFieldsExpansionState: recipientFieldsExpansionState,
    setRecipientFieldsExpansionState: setRecipientFieldsExpansionState,
    showCCBCCIconButtons: showCCBCCIconButtons
  }, recipientKey);
};
export const FieldVisibilityControls = ({
  recipientsFields,
  recipientFieldsExpansionState,
  setRecipientFieldsExpansionState,
  handleCollapseButtonOnClick,
  showCCBCCIconButtons,
  showSenderSubjectFields
}) => {
  const verticalMenuTooltip = showSenderSubjectFields ? I18n.text('composer-ui.metadata-editor.field-visibility-controls.hide-sender-and-subject') : I18n.text('composer-ui.metadata-editor.field-visibility-controls.edit-sender-and-subject');
  const buttonTestId = showSenderSubjectFields ? 'metadata-expand-button-collapse' : 'metadata-expand-button-expand';
  return /*#__PURE__*/_jsx(FieldVisibilityControlsWrapper, {
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [recipientsFields.map((recipient, index) => {
        if (index === 0) {
          /* Skips the first field as it'd always be visible */
          return null;
        }
        return renderRecipientsExpandButtons({
          recipient,
          index,
          recipientFieldsExpansionState,
          setRecipientFieldsExpansionState,
          showCCBCCIconButtons
        });
      }), /*#__PURE__*/_jsx(IconButton, {
        onClick: handleCollapseButtonOnClick,
        placement: "top",
        tooltip: verticalMenuTooltip,
        use: "link",
        "data-selenium-test": buttonTestId,
        marginInlineStart: "100",
        marginBlockStart: "0",
        children: /*#__PURE__*/_jsx(IconHolder, {
          marginInlineEnd: "0",
          icon: VerticalMenuIcon,
          size: "200",
          color: "icon-core-subtle"
        })
      })]
    })
  });
};
FieldVisibilityControls.displayName = 'FieldVisibilityControls';